<script setup lang="ts">
import { useTemplateRef } from 'vue';

import { useLongScroll } from '@libs/utils';

import TheFooter from '../../core/components/theFooter/TheFooter.vue';

interface TripOverviewPageLayoutMobileEmits {
  (eventName: 'long-scroll'): void;
}
const emit = defineEmits<TripOverviewPageLayoutMobileEmits>();

const tripOverviewPageLayoutMobileRef = useTemplateRef(
  'tripOverviewPageLayoutMobileRef'
);

const { longScrollEvent } = useLongScroll(tripOverviewPageLayoutMobileRef);

longScrollEvent.subscribe(() => emit('long-scroll'));
</script>

<template>
  <div
    ref="tripOverviewPageLayoutMobileRef"
    class="trip-overview-page-layout-mobile"
  >
    <div class="content-wrapper">
      <slot name="content" />
    </div>
    <slot name="summary" />
    <TheFooter />
  </div>
</template>

<style scoped lang="scss">
.trip-overview-page-layout-mobile {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);

  min-height: 100vh;
  min-height: 100dvh;

  //NOTE: This rule prevents the overview scrollbar from appearing behind some elements in Safari.
  transform: translateZ(0);

  .content-wrapper {
    width: 100%;
    padding-bottom: var(--spacing-24);
    background-color: var(--color-off-white);
  }
}
</style>

<style lang="scss">
* {
  box-sizing: border-box;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  background: var(--color-off-white);
}
</style>
